export const hy = {
    "n1": "Գլխավոր",
    "n2": "Պատվերներ",
    "n3": "Գործարք",
    "n4": "Թիմ",
    "n5": "Իմը",
    "t1": "Սխալ է տեղի ունեցել",
    "t2": "Պատճենումը հաջողվեց",
    "t3": "Խնդրում ենք լրացնել ամբողջ տեղեկատվությունը",
    "t4": "Բեռնվում է…",
    "t5": "Մուտքը հաջողվեց",
    "t6": "Գնահատականը պետք է լինի 3-ից բարձր",
    "t7": "Հանձնվել է",
    "t8": "Բավարար մնացորդ չկա",
    "t9": "Հանձնման սխալ",
    "t10": "Խնդրում ենք նախ կապել հասցեն, կուղղորդվի անձնական կենտրոն",
    "t11": "Հասցեն արդեն կապված է, դիմեք աջակցությանը փոփոխելու համար",
    "t12": "Փոփոխությունը հաջողվեց",
    "t13": "Փոփոխությունը ձախողվեց",
    "t14": "Խնդրում ենք դիմել աջակցությանը գաղտնաբառը փոխելու համար",
    "t15": "Գաղտնաբառի ձևաչափը սխալ է",
    "t16": "Ելքագրման հաջողություն",
    "t17": "Առավելագույն հանման գումար",
    "t18": "Նվազագույն հանման գումար",
    "t19": "Երկու գաղտնաբառերը չեն համընկնում",
    "t20": "Հուշում",
    "t21": "Ժամանակավորապես հնարավոր չէ անցնել",
    "t22": "Գաղտնաբառի ձևաչափը սխալ է",
    "t23": "Գրանցումը հաջողվեց",
    "t24": "Խնդրում ենք մուտքագրել երկրի կոդը",
    "t25": "Այլևս տվյալներ չկան",
    "l1": "Լեզու",
    "l2": "Մուտքագրեք հաշիվը",
    "l3": "Մուտքագրեք գաղտնաբառը",
    "l4": "Հիշել",
    "l5": "Մուտք",
    "l6": "Գրանցվել",
    "l7": "Հաշիվ չունե՞ք",
    "l8": "Հեռախոսահամար",
    "l9": "Մականուն",
    "l10": "Գաղտնաբառ",
    "l11": "Հաստատել գաղտնաբառը",
    "l12": "Հրավերի կոդ",
    "l13": "Գրանցում",
    "l14": "Արդեն ունեմ հաշիվ",
    "l15": "Մուտք գործել",
    "l16": "Մուտքագրեք 6-16 նիշ թվային գաղտնաբառ",
    "bz1": "Օգնություն",
    "bz2": "Հաճախ տրվող հարցեր",
    "bz3": "Գործարքի կանոններ",
    "bz4": "Ինչպես հանել միջոցներ",
    "bz5": "Ինչպես լիցքավորել",
    "bz6": "1. Ի՞նչ է TiktokShop-ը",
    "bz7": "TiktokShop-ը մարքեթինգային ընկերություն է, որը օգնում է խանութներին ստանալ ավելի շատ պատվերներ և դիտումներ։",
    "bz8": "2. Ինչպե՞ս է աշխատում TiktokShop-ը",
    "bz9": "Օգտատերը պարզապես սեղմում է պատվերը, և համակարգը ավտոմատ ստեղծում է այն։",
    "bz10": "3. Ինչու՞ նույն արժույթի գները տարբեր են",
    "bz11": "Գների տարբերությունները պայմանավորված են տարբեր գործոններով, ներառյալ ցանցը և շուկան։",
    "bz12": "4. Ներդրման շահույթ",
    "bz13": "Որքան բարձր է ապրանքի արժեքը, այնքան բարձր է շահույթը։",
    "bz14": "Համակարգը ամեն օր ստեղծում է 60 պատվեր օգտատիրոջ համար։",
    "bz15": "USDT-ը կարելի է հանել 60 պատվերից հետո։",
    "bz16": "Յուրաքանչյուր հաշիվ կարող է կապվել միայն մեկ USDT հաշվին",
    "bz17": "Հանումը կատարվում է 24 ժամվա ընթացքում",
    "bz18": "Խնդրում ենք նախ կապել ձեր հասցեն",
    "bz19": "Արգելվում է փոխադարձ փոխանցումները կապված հաշիվների միջև",
    "bz20": "Պետք է ավարտել օրական բոլոր պատվերները",
    "bz21": "Խախտումների դեպքում կիրառվում են տույժեր",
    "ty1": "Հաստատել",
    "ty2": "Չեղարկել",
    "ty3": "Ուղարկել",
    "ty4": "TRC20 հասցե",
    "ty5": "ERC20 հասցե",
    "s1": "Ընդհանուր եկամուտ",
    "s2": "Ծառայություն",
    "s3": "Մեր մասին",
    "s4": "Օգնություն",
    "s5": "Գործընկերներ",
    "s6": "Իմ ծառայությունները",
    "d1": "Չավարտված",
    "d2": "Ավարտված",
    "d3": "Տվյալներ չկան",
    "d4": "Պատվերի համար",
    "d5": "Գործարքի ժամանակ",
    "d6": "Գումար",
    "d7": "Ընթացիկ առաջադրանքներ",
    "d8": "Սպասվող շահույթ",
    "d9": "Մնացած",
    "d10": "Գնահատում",
    "j1": "Հաշվի մնացորդ",
    "j2": "Գործարքի ներկայացում",
    "j3": "Օգտատերը ստանում է հանձնաժողով յուրաքանչյուր պատվերից",
    "j4": "Սկսել",
    "j5": "Այսօրվա եկամուտ",
    "j6": "Ավարտված",
    "j7": "Ընդհանուր առաջադրանքներ",
    "td1": "Մնացորդ",
    "td2": "Հանձնաժողով",
    "td3": "Ստանալ",
    "td4": "Ընդհանուր մարդիկ",
    "td5": "Օգտատեր",
    "td6": "Ներդրում",
    "td7": "Քանակ",
    "td8": "Կարգավիճակ",
    "g1": "Հանել",
    "g2": "Լիցքավորել",
    "g3": "Հրավիրել ընկերներին",
    "g4": "Հրավիրել հիմա",
    "g5": "Ստացեք հանձնաժողով ընկերների եկամուտներից",
    "g6": "Անձնական տվյալներ",
    "g7": "Ֆինանսական պատմություն",
    "g8": "Լիցքավորման պատմություն",
    "g9": "Հանման պատմություն",
    "g10": "Լեզու",
    "g11": "Դուրս գալ",
    "g12": "Վստա՞հ եք դուրս գալու",
    "yh1": "Օգտատիրոջ տվյալներ",
    "yh2": "Խմբագրել",
    "yh3": "Կարգավորումներ",
    "yh4": "Հեռախոս",
    "yh6": "Հին գաղտնաբառ",
    "yh7": "Նոր գաղտնաբառ",
    "mx1": "Հանձնաժողով",
    "mx2": "Եկամուտ",
    "mx3": "Հանում մերժված",
    "mx4": "Ժամանակ",
    "mx5": "Լիցքավորումը հաջողվեց",
    "mx6": "Մերժված",
    "mx7": "Սպասման մեջ",
    "mx8": "Հասցե",
    "mx9": "Մնացորդ",
    "mx10": "Իրական ստացված",
    "mx11": "Մուտքագրեք գումարը",
    "cz2": "Պատճենել",
    "cz3": "Արժույթի ընտրություն",
    "cz4": "Վճարել",
    "cz5": "Աջակցվում է միայն TRC20-USDT",
    "cz6": "Աջակցվում է միայն ERC20",
    "cz1": "Աջակցվում է միայն ERC20",
    "qy1": "Կոդ",
    "yq1": "Հրավիրել ընկերներին",
    "yq2": "Հրավերի կոդ",
    "yq3": "Ստացեք մեծ եկամուտներ",
    "yq4": "Հրավիրել հիմա",
    "zf1": "Վճարման եղանակ",
    "zf2": "Ընտրեք եղանակը",
    "zf3": "Արժույթ",
    "zf4": "Ցանց",
    "zf5": "Գործարք",
    "zf6": "Պատճենումը հաջողվեց",
    "zf7": "Արժույթ",
    "zf8": "Օգտագործեք",
    "zf9": "փոխանցման համար",
    "zf10": "Արժույթ",
    "zf11": "Պատճենել",
    "zf12": "Ստուգեք հասցեն",
    "zf13": "Ժամանակ",
    "zf14": "1~5 րոպե",
    "zf15": "Նվազագույն գումար",
    "a1": "Մարքեթինգ կենտրոն",
    "a2": "Օգնում է բարձրացնել վաճառքները",
    "a3": "Օգտատերերը ստանում են հանձնաժողովներ",
    "a4": "Շարունակական զարգացում",
    // Հաճախորդների սպասարկում
    "kf1": "Առցանց հաճախորդների սպասարկում",
    "kf2": "Ձեռքով կանխիկացման աջակցություն",
    "kf3": "Կարող եք սեղմել այստեղ կանխիկացման համար հաճախորդների սպասարկման հետ կապ հաստատելու համար",
    "kf4": "Ձեռքով լիցքավորման աջակցություն",
    "kf5": "Կարող եք սեղմել այստեղ լիցքավորման համար հաճախորդների սպասարկման հետ կապ հաստատելու համար",
    // Վճարման ընտրանքների պատուհան
    "zf16": "Բանկային քարտով գործարքների համար դիմեք հաճախորդների սպասարկմանը",
    "zf17": "Կապ հաճախորդների սպասարկման հետ"
   }